import { create } from 'zustand';

interface MapsQuotaState {
  /** True once the backend has refused a Maps call for going over the cap. */
  exceeded: boolean;
  /** ISO date the monthly cap resets, when the backend told us. */
  resetsAt: string | null;
  markExceeded: (resetsAt?: string) => void;
  clear: () => void;
}

/**
 * The Maps cap is a whole-account state, not a per-request error: once it's hit,
 * every place and route call fails until the month rolls over. A toast scrolls
 * away and leaves the user staring at a map that silently stopped working, so
 * the map screens read this and say what's going on.
 */
export const useMapsQuotaStore = create<MapsQuotaState>(set => ({
  exceeded: false,
  resetsAt: null,
  markExceeded: (resetsAt) => set({ exceeded: true, resetsAt: resetsAt ?? null }),
  clear: () => set({ exceeded: false, resetsAt: null }),
}));
